const TypeOfInstitutionComponent = (props) => {

    console.log("Type of institution component => ", props.value);

    return (
        <div>
            <label htmlFor="typeOfInstitution" className="block text-sm font-medium leading-6 text-gray-900">
                Set type of institution</label>
            <div className="mt-2">
                <select value={props.value} onChange={props.onChange} id="priority" name="priority"
                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6">
                    <option value={'Practise'}>Practise</option>
                    <option value={'Clinic'}>Clinic</option>
                    <option value={'Partner'}>Partner</option>
                    <option value={'Media'}>Media</option>
                    <option value={'Other'}>Other</option>
                </select>
            </div>
        </div>
    )
}

export default TypeOfInstitutionComponent;